// eslint-disable-next-line
export default {
  id: 'pavlova',
  type: 'sweet',
  title: 'Pavlova',
  ingredients: [
    '8 claras de ovo',
    '2 xícaras de açúcar de confeiteiro',
    '1 colher de sopa de vinagre de maçã',
    '2 colheres de chá de amido de milho',
    '1 tampa de essência de baunilha',
    '? Frutas (morango e kiwi) para calda e para colocar em cima',
    '1 garrafinha de creme de leite fresco e gelado (200ml)',
    '2 colheres de iogurte natural sem açúcar',
    '2 colheres de açúcar',
    '? Essência de baunilha',
  ],
  parts: [
    {
      title: 'Base',
      methodOfPreparation: [
        'Bate as 8 claras até ficar firme',
        'Colocar o açúcar, amido, vinagre e baunilha até fazer bico',
        'Estando firme no ponto de suspiro, em uma travessa sem borda alta, faz tipo um ninho: coloca o suspiro e amassa para formar um disco e uns 4 dedos de altura, sendo o centro mais baixo (onde vai colocar o recheio)',
        'Leva pro forno na temperatura mínima 90 graus de tiver, por 1 hora e meia/2 horas). Lá pra 1:30 da uma olhada',
      ],
    },
    {
      title: 'Calda',
      methodOfPreparation: [
        'Corta as frutas em pedaços pequenos',
        'Coloca as frutas e um pouco de açúcar (o intuito não eh deixar doce, apenas para que consiga derreter e virar a calda)',
        'Deixa na panela sem mexer em fogo baixo até virar calda',
      ],
    },
    {
      title: 'Chantilly',
      methodOfPreparation: [
        'Em um bowl, coloca o creme de leite, iogurte, açúcar, baunilha',
        'Com um fouet bate por uns 3 min',
        'Eh só até ficar mais consistente. Se bater muito vira manteiga, cuidado',
      ],
    },
    {
      title: 'Finalização',
      methodOfPreparation: [
        'Coloca o chantilly em cima a base',
        'Coloca as frutas cortadas',
        'Coloca a calda',
      ],
    },
  ],
};
